import { FC } from 'react';
import { Tooltip } from './Tooltip';
import { Icon } from '../icons';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  icon: React.VFC<React.SVGProps<SVGSVGElement>>;
  tooltipText: string;
};

export const ControlButton: FC<Props> = ({
  disabled,
  icon,
  onClick,
  tooltipText,
}) => {
  return (
    <Tooltip
      hideArrow
      sideOffset={4}
      trigger={
        <div>
          <button
            className="p-1 rounded-lg hover:bg-base-white/[0.1] text-base-white disabled:text-gray-400 disabled:hover:bg-transparent"
            disabled={disabled}
            onClick={onClick}
          >
            <Icon svg={icon} size="xs" />
          </button>
        </div>
      }
    >
      {tooltipText}
    </Tooltip>
  );
};
